import React from 'react'
import tw from 'tailwind-styled-components'

export type Position = 'right' | 'left' | 'up' | 'down'

interface Props {
  tooltipPosition: Position
  children?: React.ReactNode
  offsetX: number
  offsetY: number
  direction?: Position
  centerY?: boolean
}

const TwContainer = tw.div`
  absolute
  left-0
  z-10
`

export const ToolTipPosition = (props: Props) => {
  const {tooltipPosition, children} = props
  const {offsetX, offsetY, direction = 'down', centerY = false} = props

  if (tooltipPosition === 'right') {
    const style: React.CSSProperties = {
      left: `calc(100% + 10px + ${offsetX}px)`
    }

    if (centerY) {
      style.translate = '0 -50%'
    }

    if (direction === 'down') {
      style.top = `${offsetY}px`
    } else if (direction === 'up') {
      style.bottom = `${offsetY}px`
    }

    return <TwContainer style={style}>{children}</TwContainer>
  }

  if (tooltipPosition === 'down') {
    return (
      <TwContainer style={{top: `calc(100% + 10px)`}}>{children}</TwContainer>
    )
  }

  return <>{children}</>
}
